import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import StayTop from "../components/StayTop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faStar, faUsers, faShoppingBag, faRocket } from "@fortawesome/free-solid-svg-icons";

/* ============================================
   CHANGES MADE:
   1. REMOVED: Gradient hero section (.about-hero)
   2. REPLACED: With simple clean header (no background box)
   3. KEPT: All other sections unchanged
   4. CLEANED: Removed unused hero CSS
   ============================================ */

const About = () => {
    const navigate = useNavigate();

    return (
        <>
            <style>{`
                /* ============================================
                   REMOVED: .about-hero gradient section
                   REMOVED: .about-hero h1, .about-hero p styles
                   ============================================ */

                .about-content-section {
                    padding: 3rem 0;
                }

                .about-content-section h2 {
                    color: #3E6D9C;
                    font-weight: 700;
                    font-size: 2.5rem;
                    margin-bottom: 1.5rem;
                    text-align: center;
                }

                .about-content-section p {
                    font-size: 1.1rem;
                    line-height: 1.8;
                    color: #666;
                    margin-bottom: 1.5rem;
                }

                .value-card {
                    background: white;
                    border-radius: 15px;
                    padding: 2rem;
                    margin-bottom: 2rem;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                    border: 2px solid #f8f9fa;
                    height: 100%;
                    text-align: center;
                }

                .value-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 30px rgba(0,0,0,0.15);
                    border-color: #FD7014;
                }

                .value-icon {
                    font-size: 3.5rem;
                    color: #FD7014;
                    margin-bottom: 1rem;
                }

                .value-title {
                    font-size: 1.3rem;
                    font-weight: 700;
                    color: #3E6D9C;
                    margin-bottom: 1rem;
                }

                .value-description {
                    color: #666;
                    line-height: 1.6;
                    font-size: 1rem;
                }

                .story-section {
                    background: #f8f9fa;
                    padding: 4rem 0;
                    margin: 3rem 0;
                }

                .testimonial-card {
                    background: white;
                    border-radius: 15px;
                    padding: 2rem;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
                    position: relative;
                    margin-bottom: 2rem;
                }

                .testimonial-card::before {
                    content: '"';
                    font-size: 5rem;
                    color: #FD7014;
                    opacity: 0.2;
                    position: absolute;
                    top: -10px;
                    left: 20px;
                    font-family: Georgia, serif;
                }

                .testimonial-quote {
                    font-size: 1.1rem;
                    line-height: 1.8;
                    color: #333;
                    font-style: italic;
                    margin-bottom: 1rem;
                    position: relative;
                }

                .testimonial-author {
                    font-weight: 600;
                    color: #3E6D9C;
                    text-align: right;
                }

                .cta-section {
                    background: linear-gradient(135deg, #3E6D9C 0%, #FD7014 100%);
                    color: white;
                    padding: 4rem 2rem;
                    border-radius: 20px;
                    text-align: center;
                    margin: 3rem 0;
                }

                .cta-section h3 {
                    font-size: 2.5rem;
                    font-weight: 700;
                    margin-bottom: 1rem;
                }

                .cta-section p {
                    font-size: 1.2rem;
                    margin-bottom: 2rem;
                    opacity: 0.95;
                }

                .cta-button {
                    display: inline-block;
                    padding: 1rem 3rem;
                    background: white;
                    color: #FD7014;
                    font-size: 1.2rem;
                    font-weight: 700;
                    border-radius: 50px;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    border: 3px solid white;
                }

                .cta-button:hover {
                    background: transparent;
                    color: white;
                    transform: translateY(-3px);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                }

                .stats-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 2rem;
                    margin: 3rem 0;
                }

                .stat-card {
                    text-align: center;
                    padding: 2rem;
                    background: white;
                    border-radius: 15px;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
                }

                .stat-number {
                    font-size: 3rem;
                    font-weight: 800;
                    color: #FD7014;
                    margin-bottom: 0.5rem;
                }

                .stat-label {
                    font-size: 1.1rem;
                    color: #3E6D9C;
                    font-weight: 600;
                }

                /* NEW: Simple clean header styles */
                .simple-header {
                    text-align: center;
                    margin: 4rem 0 3rem;
                }

                .simple-header h1 {
                    color: #3E6D9C;
                    font-size: 3.5rem;
                    font-weight: 800;
                    margin-bottom: 1rem;
                }

                .simple-header p {
                    font-size: 1.3rem;
                    color: #666;
                    max-width: 700px;
                    margin: 0 auto;
                    line-height: 1.6;
                }

                @media (max-width: 768px) {
                    /* REMOVED: .about-hero mobile styles */

                    .simple-header h1 {
                        font-size: 2.5rem;
                    }

                    .simple-header p {
                        font-size: 1.1rem;
                        padding: 0 1rem;
                    }

                    .about-content-section h2 {
                        font-size: 2rem;
                    }

                    .value-card {
                        padding: 1.5rem;
                    }

                    .value-icon {
                        font-size: 2.5rem;
                    }

                    .cta-section h3 {
                        font-size: 1.8rem;
                    }

                    .cta-section p {
                        font-size: 1rem;
                    }
                }
            `}</style>

            <StayTop />

            {/* Back Button */}
            <Container style={{marginTop: '2rem'}}>
                <Link className="btn btn-light orange-outline" onClick={() => navigate(-1)}>
                    ← Go Back
                </Link>
            </Container>

            {/* ============================================
                CHANGED: Replaced gradient hero with simple clean header
                OLD: <div className="about-hero"> with gradient background
                NEW: <Container> with simple text, no background
                ============================================ */}
            <Container className="simple-header">
                <h1>Welcome to RetroDayz</h1>
                <p>Your Nostalgia Haven - Where Memories Are Just a Click Away!</p>
            </Container>

            {/* Our Story - UNCHANGED */}
            <Container className="about-content-section">
                <Row>
                    <Col lg={10} className="mx-auto">
                        <h2>Our Story</h2>
                        <p>
                            Dive into the golden days of gaming and pop culture with RetroDayz, where memories are just a click away.
                            We are a passionate team of enthusiasts, dedicated to bringing the past right to your doorstep.
                        </p>
                        <p>
                            Our journey began as a small group of friends reminiscing about the good old days, trading games,
                            and sharing stories of our favourite movie scenes. This shared passion led to the creation of RetroDayz,
                            a place where like-minded hobbyists can relive the thrill of retro gaming and pop culture.
                        </p>
                        <p>
                            Our carefully curated collection features a range of merchandise that will grow and grow as we become more
                            established, to include t-shirts, mugs, cuddly plush, collectable items and lighting, all inspired by the
                            iconic eras of movies, gaming and timeless TV.
                        </p>
                        <p>
                            As a small startup, we resonate with the collector's spirit and aim to provide high-quality,
                            unique products that celebrate the classics of the '80s, '90s, and early '00s.
                            Whether you're a chilled gamer, a movie buff, or someone who appreciates the charm of yesteryears,
                            we've got something special for you.
                        </p>
                    </Col>
                </Row>
            </Container>

            {/* Why Choose Us - UNCHANGED */}
            <div className="story-section">
                <Container>
                    <h2 style={{textAlign: 'center', color: '#3E6D9C', fontWeight: '700', fontSize: '2.5rem', marginBottom: '3rem'}}>
                        Why Choose RetroDayz?
                    </h2>
                    <Row>
                        <Col md={6} lg={3}>
                            <div className="value-card">
                                <div className="value-icon">
                                    <FontAwesomeIcon icon={faShoppingBag} />
                                </div>
                                <h4 className="value-title">Curated Collection</h4>
                                <p className="value-description">
                                    From retro and modern gaming, TV, or movies, our products are designed to evoke nostalgia
                                    and bring a piece of history into your everyday life.
                                </p>
                            </div>
                        </Col>
                        <Col md={6} lg={3}>
                            <div className="value-card">
                                <div className="value-icon">
                                    <FontAwesomeIcon icon={faStar} />
                                </div>
                                <h4 className="value-title">Quality You Can Trust</h4>
                                <p className="value-description">
                                    We understand the value of every item we sell and ensure the highest quality
                                    standards for all our products.
                                </p>
                            </div>
                        </Col>
                        <Col md={6} lg={3}>
                            <div className="value-card">
                                <div className="value-icon">
                                    <FontAwesomeIcon icon={faUsers} />
                                </div>
                                <h4 className="value-title">Community of Enthusiasts</h4>
                                <p className="value-description">
                                    Join our community of retro lovers! Share stories, participate in discussions,
                                    and stay updated with the latest additions to our collection.
                                </p>
                            </div>
                        </Col>
                        <Col md={6} lg={3}>
                            <div className="value-card">
                                <div className="value-icon">
                                    <FontAwesomeIcon icon={faHeart} />
                                </div>
                                <h4 className="value-title">Customer-Centric Service</h4>
                                <p className="value-description">
                                    Your satisfaction is our priority. We're here to assist you with any queries
                                    and ensure a smooth, enjoyable shopping experience.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Stats - UNCHANGED */}
            <Container>
                <div className="stats-grid">
                    <div className="stat-card">
                        <div className="stat-number">100's</div>
                        <div className="stat-label">Products</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-number">🤗</div>
                        <div className="stat-label">Happy Customers</div>
                    </div>
                </div>
            </Container>

            {/* Testimonials - UNCHANGED */}
            <Container style={{marginTop: '4rem'}}>
                <h2 style={{textAlign: 'center', color: '#3E6D9C', fontWeight: '700', fontSize: '2.5rem', marginBottom: '3rem'}}>
                    What Our Customers Say
                </h2>
                <Row>
                    <Col lg={8} className="mx-auto">
                        <div className="testimonial-card">
                            <p className="testimonial-quote">
                                "I love Retrodayz! Their products always bring back fond memories of my childhood.
                                The quality is excellent and the customer service is outstanding. Highly recommended!"
                            </p>
                            <p className="testimonial-author">- Phil Williams</p>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* CTA Section - UNCHANGED (kept the gradient here as it's in a card) */}
            <Container>
                <div className="cta-section">
                    <FontAwesomeIcon icon={faRocket} style={{fontSize: '4rem', marginBottom: '1.5rem'}} />
                    <h3>Embark on a Nostalgic Journey!</h3>
                    <p>
                        Explore a world of retro gaming, classic movies, and series merchandise.<br/>
                        After all, nostalgia never goes out of style!
                    </p>
                    <Link to="/" className="cta-button">
                        Start Shopping Now
                    </Link>
                </div>
            </Container>

            {/* Thank You Section - UNCHANGED */}
            <Container style={{marginTop: '4rem', marginBottom: '4rem', textAlign: 'center'}}>
                <h3 style={{color: '#3E6D9C', fontWeight: '700', fontSize: '2rem', marginBottom: '1rem'}}>
                    Thank You for Visiting RetroDayz!
                </h3>
                <p style={{fontSize: '1.1rem', color: '#666', maxWidth: '600px', margin: '0 auto 2rem'}}>
                    We appreciate your interest in our brand. Feel free to <Link to="/contact">reach out to us</Link> if
                    you have any questions or feedback. Happy shopping!
                </p>
            </Container>
        </>
    );
};

export default About;